import { supabase } from '../../supabaseClient';

const NON_CLONABLE_FIELDS = [
  'id',
  'code',
  'created_at',
  'updated_at',
  'deleted_at',
  'deleted_by',
  'Vehicle',
  'client_name',
];

const dateWithoutTimezone = (date) => {
  const tzoffset = date.getTimezoneOffset() * 60000;
  return new Date(date.valueOf() - tzoffset).toISOString().slice(0, -1);
};

export const buildClonePayload = (original, newCode) => {
  const payload = { ...original };
  NON_CLONABLE_FIELDS.forEach((field) => delete payload[field]);
  payload.code = newCode;
  payload.shared_at = null;
  return payload;
};

export const generateBudgetCode = async (companyId) => {
  const today = new Date();
  const year = today.getFullYear().toString().slice(-2);
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const dayPrefix = dateWithoutTimezone(today).slice(0, 10);
  const { data: existingBudgets } = await supabase
    .from('Budget')
    .select('id')
    .is('deleted_at', null)
    .eq('id_company', companyId)
    .gte('created_at', `${dayPrefix}T00:00:00`)
    .lte('created_at', `${dayPrefix}T23:59:59`);
  const codeNumber = String(existingBudgets?.length || 0).padStart(2, '0');
  return `O${year}${month}${day}${codeNumber}`;
};

export const cloneBudget = async (originalId, companyId) => {
  const { data: rows, error: fetchError } = await supabase
    .from('Budget')
    .select('*')
    .eq('id', originalId)
    .is('deleted_at', null);

  if (fetchError) return { data: null, error: fetchError };
  if (!rows?.[0])
    return { data: null, error: { message: 'Orçamento não encontrado' } };

  const newCode = await generateBudgetCode(companyId);
  const payload = buildClonePayload(rows[0], newCode);

  return await supabase.from('Budget').insert([payload]).select('*');
};

export const saveBudget = async (id = undefined, item) => {
  if (id) {
    return await supabase
      .from('Budget')
      .update({ ...item })
      .match({ id })
      .select(
        `
        *,
        Vehicle(responsible, *)
        `
      );
  } else {
    return await supabase.from('Budget').insert([{ ...item }]);
  }
};

export const savePaymentTypes = async (item) => {
  return await supabase.from('PaymentTypes').insert([{ ...item }]);
};

export const saveConsultant = async (item) => {
  return await supabase.from('Consultants').insert([{ ...item }]);
};

export const saveTypeOS = async (item) => {
  return await supabase.from('TypeOS').insert([{ ...item }]);
};

export const deletedBudget = async (id = undefined, user_id) => {
  if (id) {
    return await supabase
      .from('Budget')
      .update({ deleted_at: new Date(), deleted_by: user_id })
      .eq('id', id);
  }
};
